export default class Address {
  constructor(
    public streetAddress?: string,
    public city?: string,
    public state?: string,
    public postalCode?: string,
    public country?: string,
  ) {}

  // parse() in bookshelf won't add class functions to the model >:(
  // So until we can migrate to TypeORM, we need to use this static function
  static formatAddressToString(address: Address, withNewLines = true): string {
    const delimiter = withNewLines ? '\n' : ';';
    const addressParts = [];

    if (address.streetAddress) addressParts.push(address.streetAddress);
    let cityStateZip = '';
    if (address.city || address.state || address.postalCode) {
      cityStateZip += address.city ? `${address.city}, ` : '';
      cityStateZip += address.state ? `${address.state} ` : '';
      // Trim off the .0 from the postal code if it's present
      const formattedPostalCode = address.postalCode
        ? address.postalCode.replace(/\.0$/, '')
        : '';
      cityStateZip += formattedPostalCode;
      cityStateZip = cityStateZip.trim().replace(/,$/, '');
      addressParts.push(cityStateZip);
    }

    if (address.country) addressParts.push(address.country);

    return addressParts.join(delimiter).trim();
  }

  formatAddress(): string {
    return Address.formatAddressToString(this);
  }
}
